import './Home.css';
import React, { useContext, useEffect } from 'react';
import Landingfold from './landingfold/Landingfold';
import Achievements from './achievements/Achievements';
import WelcomeTo from './welcometo/WelcomeTo';
import Featuredservices from './featuredservices/Featuredservices';
import WhyUs from './whyus/WhyUs';
import Services from '../services/Services';
import Doctors from './doctors/Doctors';
import TestimonialSlider from './testimonials/Testimonial';
import YoutubeWrap from './youtubevideo/YoutubeWrap';
import Values from './values/Values';
import Blogs from './blogs/Blogs';
import Faq from './faq/Faq';
import Contact from './contact/Contact';
import CtaBand from './ctaband/CtaBand';
import progressContext from '../../context/loading/progresscontext';

function Home() {
    const { setProgress } = useContext(progressContext);

    useEffect(() => {
        if (setProgress) {
            setProgress(70);
            setTimeout(() => {
                setProgress(100);
            }, 100);
        }
    }, [setProgress]);

    return (
        <main id="main">
            <Landingfold />
            <Achievements />
            <WelcomeTo />
            <Featuredservices />
            <WhyUs />
            <Services />
            <Doctors />
            <TestimonialSlider />
            <YoutubeWrap />
            <Values />
            <Blogs />
            <Faq />
            <Contact />
            <CtaBand />
        </main>
    );
}

export default Home;
